import moment from "moment";
import React, { Component } from "react";
import Pagination from "react-js-pagination";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {
  postedCampusInternshipList,
  closeInternship,
  addJobComment,
  deleteJobComment,
  updateCampusInternshipStatus,
} from "../../action/jobs";
import constant from "../../constant";
import { getStorage, onChange, ToSeoUrl, validateForm } from "../../utils";
import Shimmer from "../Common/Shimmer";
export default class JobList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      FILTER_BY: {
        name: "FILTER_BY",
        value: props.FILTER_BY ? props.FILTER_BY : "ALL",
        options: ["ALL", "CLOSED", "OPEN", "ON HOLD"],
        error: "",
      },
      LIMIT: {
        name: "LIMIT",
        value: props.LIMIT ? props.LIMIT : 10,
        options: [10, 20, 40, 50],
        error: "",
      },
      PAGE: { name: "PAGE", value: props.PAGE ? props.PAGE : 1, error: "" },
      KEYWORD: {
        name: "KEYWORD",
        value: props.KEYWORD ? props.KEYWORD : "",
        error: "",
        isRequired: true,
      },
      COUNT: props.COUNT,
      LIST: props.LIST ? props.LIST : undefined,
      COMMENT: { name: "COMMENT", value: "", error: "", isRequired: false },
      jobActiveNess: {
        OPEN: ["CLOSE", "ON HOLD"],
        CLOSE: ["OPEN", "ON HOLD"],
        ON_HOLD: ["CLOSE", "OPEN"],
      },
      openedCommentBoxJobId: undefined,
      showCommentBox: false,
    };
  }
  componentDidMount() {
    this.loadList();
  }

  handleReset = (e) => {
    let k = this.state.KEYWORD
    k.value = ''
    this.setState({ KEYWORD: k })
    this.loadList();
  }

  onChange = (e) => {
    this.setState({ COMMENT: { ...this.COMMENT, value: e.target.value } });
    const { name, value } = e.target;

    onChange(this, name, value);

    if (name === "FILTER_BY") {
      this.props.onFilterChange(value);
    } else if (name === "LIMIT") {
      this.props.onLimitChange(value);
    }
  };

  onPageChange = (input) => {
    onChange(this, this.state.PAGE.name, input);
    this.props.onPageChange(input);
  };

  onSearch = (e) => {
    e.preventDefault();
    const { FILTER_BY, LIMIT, PAGE, KEYWORD } = this.state;
    if (validateForm(this)) {
      window.location.href =
        constant.component.campusInternshipList.url +
        `?f=${FILTER_BY.value}&l=${LIMIT.value}&p=${PAGE.value}&k=${KEYWORD.value}`;
    }
  };

  UpdateJobStatus = (item) => {
    closeInternship({
      INTERNSHIP_ID: item.INTERNSHIP_ID,
      STATUS: item.STATUS === "A" ? "U" : "A",
    }).then((res) => {
      if (res.status) {
        window.location.reload();
      }
    });
  };

  showTextArea = (item) => {
    if (this.state.openedCommentBoxJobId || item.INTERNSHIP_ID) {
      this.setState({ showCommentBox: true });
      // this.setState({ openedCommentBoxJobId: undefined })
      this.setState({ COMMENT: { ...this.COMMENT, value: "" } });
      // this.setState({ openedCommentBoxJobId: item.INTERNSHIP_ID })
      if (this.state.openedCommentBoxJobId == item.INTERNSHIP_ID) {
        this.setState({ openedCommentBoxJobId: undefined });
      } else {
        this.setState({ openedCommentBoxJobId: item.INTERNSHIP_ID });
      }
    } else {
      this.setState({ openedCommentBoxJobId: item.INTERNSHIP_ID });
    }
  };

  updateEmployerJobStatus = (STATUS, INTERNSHIP_ID) => {
    const model = {
      STATUS: STATUS,
      INTERNSHIP_ID: INTERNSHIP_ID,
    };

    updateCampusInternshipStatus(model).then((res) => {
      if (res.status) {
        window.location.reload();
      } else {
        Swal.fire({
          icon: "error",
          text: res.error,
          timer: 1500,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    });
  };
  render() {
    const {
      FILTER_BY,
      LIMIT,
      PAGE,
      COUNT,
      LIST,
      KEYWORD,
      COMMENT,
      openedCommentBoxJobId,
      jobActiveNess,
    } = this.state;
    const { ATS_ENABLED } = this.props;
    return (
      <React.Fragment>
        <section className="pricing-area posted-list-job padding-top-70px padding-bottom-80px">
          <div className="filterareabox">
            <div className="filterareasearch filterareasearchRequirements">
              <div className="container">
                <div className="row">
                  <div className="col-md-4">
                    <h1 className="pt-2">List of Requirements</h1>
                  </div>

                  <div className="col-md-6">
                    {/* <div className='rseachbox'> */}
                    <form className="rseachbox" onSubmit={this.onSearch}>
                      <input
                        // className={KEYWORD.error.length ? "form-control is-invalid" : "form-control"}
                        placeholder="Internship Title, Internship Id ..."
                        name={KEYWORD.name}
                        value={KEYWORD.value}
                        onChange={this.onChange}
                        type="text"
                      />
                      <button type="submit">Search</button>
                      &nbsp;{" "}
                      <button type="button" className="btn btn-outline-danger btn-outline-reset"
                        onClick={() => this.handleReset()}>
                        Reset
                      </button>
                    </form>
                  </div>

                  <div className="col-md-2 text-right">
                    <Link
                      to={constant.component.PostInternship.url}
                      className="btn btn-danger btn-sm p-2 post-job-btn"
                    >
                      Post New Job
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row row-fltir">



                <div className="col-md-6 col-6">
                  <div className="filterbox filterbox-left" style={{ margin: "4px" }}>
                    <p>Filter&nbsp;by</p>
                    <select
                      name={FILTER_BY.name}
                      value={FILTER_BY.value}
                      onChange={this.onChange}
                    >
                      {FILTER_BY.options.map((item) => {
                        return <option value={item}>{item}</option>;
                      })}
                    </select>
                    {/* <i class="fa fa-filter" aria-hidden="true"></i> */}
                  </div>
                </div>
                <div className="col-md-6 col-6">
                  <div className="pagenumnerarea pagenumnerarea-nbr" style={{ margin: "4px" }}>
                    <p>Show</p>
                    <select
                      name={LIMIT.name}
                      value={LIMIT.value}
                      onChange={this.onChange}
                    >
                      {LIMIT.options.map((item) => {
                        return <option value={item}>{item}</option>;
                      })}
                    </select>
                    <p>Per Page</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive joblist-tablebx">
                  <table class="table">
                    <thead>
                      <tr>
                        <th style={{ width: "2%" }}>
                          <p>&nbsp;</p>
                        </th>
                        <th>
                          <p>
                          Internship Id
                          </p>
                        </th>
                        <th>
                          <p>
                          Internship Title (On Campus Responses / Off Campus Responses)
                          </p>
                        </th>
                        <th style={{width:"150px"}}>
                          <p>Internship Status</p>
                        </th>
                        <th style={{width:"200px"}}>
                          <p>	Last Updated</p>
                        </th>

                        <th style={{width:"300px", minWidth: "300px"}}>
                          <p>

                            Action
                          </p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {LIST === undefined && (
                        <tr>
                          <td colSpan={10} style={{ width: "100%" }}>
                            <Shimmer />
                          </td>
                        </tr>
                      )}
                      {LIST !== undefined && LIST.length == 0 && (
                        <tr>
                          <td
                            colSpan={10}
                            style={{ width: "100%" }}
                            className={"text-danger text-center"}
                          >
                            No Posted Internship Record Found.
                          </td>
                        </tr>
                      )}
                      {LIST !== undefined &&
                        LIST.map((item, index) => {
                          return (
                            <>
                              <tr>
                                <th scope="row">
                                  {/* <input type='checkbox' /> */}
                                </th>
                                <td><h3 className="joblisttablhead">{item.CUSTOM_INTERNSHIP_ID} </h3>  </td>
                                <td>
                                  {item.applyCount == 0 ? (
                                    <h3 className="joblisttablhead">
                                      {item.JOB_TITLE}({item.applyCount})
                                    </h3>
                                  ) : (
                                    <h3 className="joblisttablhead">
                                      <Link
                                        target="_blank"
                                        to={
                                          constant.component.CampusInternshipApplicationList
                                            .url +
                                          `?job=${ToSeoUrl(item.JOB_TITLE)}&id=${item.INTERNSHIP_ID
                                          }&l=${10}&p=${1}&s=all`
                                        }
                                      >
                                        {item.JOB_TITLE} ({item.applyCount} / {item.offCampusApplyCount})
                                      </Link>
                                    </h3>
                                  )}
                                  {/* <h3 className='joblisttablhead'><Link target="_blank" to={constant.component.CampusInternshipApplicationList.url + `?job=${ToSeoUrl(item.JOB_TITLE)}&id=${item.INTERNSHIP_ID}&l=${10}&p=${1}&s=all`}>{item.JOB_TITLE}</Link></h3> */}
                                  {/* <p>3 Sources Created By You Visible toall</p> */}

                                </td>
                                <td>
                                  <span
                                    className={
                                      item.STATUS === "U" &&
                                        item.STATUS_BY_EMPLOYER === "OPEN"
                                        ? "badge badge-pill badge-success badge-block"
                                        : "badge badge-pill badge-warning badge-block"
                                    }
                                  >
                                    {item.STATUS === "U" &&
                                      item.STATUS_BY_EMPLOYER === "OPEN"
                                      ? "Active"
                                      : item.STATUS === "A" &&
                                        item.STATUS_BY_EMPLOYER === "OPEN"
                                        ? "PENDING"
                                        : item.STATUS_BY_EMPLOYER}
                                  </span>
                                </td>
                                <td>
                                  <p>
                                    {moment(item.MODIFIED_ON).format(
                                      "DD MMM YYYY"
                                    )}
                                  </p>
                                </td>
                                <td>
                                  <ul class="list-inline list-inline-action">
                                    <li class="list-inline-item">
                                      <div class="dropdown">
                                        <button
                                          class="btn btn-default btn-sm dropdown-toggle"
                                          type="button"
                                          data-toggle="dropdown"
                                        >
                                          Modify
                                          <span class="caret"></span>
                                        </button>
                                        <ul class="dropdown-menu">
                                          <li>
                                            <a
                                              href={
                                                constant.component.EditInternship.url +
                                                "?job=" +
                                                ToSeoUrl(item.JOB_TITLE) +
                                                "&i=" +
                                                item.INTERNSHIP_ID
                                              }
                                            >
                                              Edit
                                            </a>
                                          </li>
                                          {item.STATUS === "U" && (
                                            <li>
                                              <a
                                                href="javascript:void(0)"
                                                onClick={() =>
                                                  this.UpdateJobStatus(item)
                                                }
                                              >
                                                Close
                                              </a>
                                            </li>
                                          )}
                                          <li>
                                            <a
                                              href={
                                                constant.component
                                                  .CampusInternshipApplicationList.url +
                                                `?job=${ToSeoUrl(
                                                  item.JOB_TITLE
                                                )}&id=${item.INTERNSHIP_ID
                                                }&l=${10}&p=${1}&s=all`
                                              }
                                            >
                                              Edit Response Filters
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </li>
                                    {/* <li class="list-inline-item">
                                                                <div class="dropdown">
                                                                    <button class="btn btn-default btn-sm dropdown-toggle" type="button" data-toggle="dropdown">Search
                                                                        <span class="caret"></span></button>
                                                                    <ul class="dropdown-menu">
                                                                        <li><a href="#">My Database</a></li>
                                                                        <li><a href="#">HRMS</a></li>
                                                                    </ul>
                                                                </div>
                                                            </li> */}
                                    <li class="list-inline-item">
                                      <div class="dropdown">
                                        <button
                                          class="btn btn-default btn-sm dropdown-toggle"
                                          type="button"
                                          data-toggle="dropdown"
                                        >
                                          {item.STATUS_BY_EMPLOYER}
                                          <span class="caret"></span>
                                        </button>
                                        <ul class="dropdown-menu">
                                          {item.STATUS_BY_EMPLOYER === "OPEN" &&
                                            jobActiveNess.OPEN.map((i) => {
                                              return (
                                                <li>
                                                  <a
                                                    onClick={() => {
                                                      this.updateEmployerJobStatus(
                                                        i,
                                                        item.INTERNSHIP_ID
                                                      );
                                                    }}
                                                    href="javascript:void(0)"
                                                  >
                                                    {i}
                                                  </a>
                                                </li>
                                              );
                                            })}

                                          {item.STATUS_BY_EMPLOYER === "CLOSE" &&
                                            jobActiveNess.CLOSE.map((i) => {
                                              return (
                                                <li>
                                                  <a
                                                    onClick={() => {
                                                      this.updateEmployerJobStatus(
                                                        i,
                                                        item.INTERNSHIP_ID
                                                      );
                                                    }}
                                                    href="javascript:void(0)"
                                                  >
                                                    {i}
                                                  </a>
                                                </li>
                                              );
                                            })}

                                          {item.STATUS_BY_EMPLOYER ===
                                            "ON HOLD" &&
                                            jobActiveNess.ON_HOLD.map((i) => {
                                              return (
                                                <li>
                                                  <a
                                                    onClick={() => {
                                                      this.updateEmployerJobStatus(
                                                        i,
                                                        item.INTERNSHIP_ID
                                                      );
                                                    }}
                                                    href="javascript:void(0)"
                                                  >
                                                    {i}
                                                  </a>
                                                </li>
                                              );
                                            })}
                                        </ul>
                                      </div>
                                    </li>
                                    <li class="list-inline-item">
                                      <div class="dropdown">
                                        <button
                                          class="btn btn-default btn-sm dropdown-toggle"
                                          type="button"
                                          data-toggle="dropdown"
                                        >
                                          More Actions
                                          <span class="caret"></span>
                                        </button>
                                        <ul class="dropdown-menu">
                                          <li>
                                            <a
                                              href={
                                                constant.component.EditInternship.url +
                                                "?job=" +
                                                ToSeoUrl(item.JOB_TITLE) +
                                                "&i=" +
                                                item.INTERNSHIP_ID
                                              }
                                            >
                                              Edit
                                            </a>
                                          </li>
                                          <li>
                                            <a
                                              href={
                                                constant.component
                                                  .CampusInternshipApplicationList.url +
                                                `?job=${ToSeoUrl(
                                                  item.JOB_TITLE
                                                )}&id=${item.INTERNSHIP_ID
                                                }&l=${10}&p=${1}&s=all`
                                              }
                                            >
                                              Download Application
                                            </a>
                                          </li>
                                          {ATS_ENABLED && (
                                            <li>
                                              <a
                                                target="_blank"
                                                href={
                                                  constant.component
                                                    .onBoardCandidate.url +
                                                  `?job=${ToSeoUrl(
                                                    item.JOB_TITLE
                                                  )}&id=${item.INTERNSHIP_ID}`
                                                }
                                              >
                                                OnBoard New Candidate
                                              </a>
                                            </li>
                                          )}
                                          {/* <li><a href="#">Share with Vendor</a></li> */}
                                        </ul>
                                      </div>
                                    </li>
                                    <li class="list-inline-item">
                                      <div class="dropdown">
                                        <button
                                          class="btn btn-default btn-sm dropdown-toggle"
                                          type="button"
                                          onClick={() => {
                                            this.showTextArea(item);
                                          }}
                                        >
                                          <i className="fa fa-comments"></i>
                                          <span class="caret"></span>
                                        </button>
                                      </div>
                                    </li>
                                  </ul>
                                  {/* {item.applyCount == 0 ? (
                                    <p>{item.applyCount}</p>
                                  ) : (
                                    <Link
                                      target="_blank"
                                      to={
                                        constant.component.CampusInternshipApplicationList
                                          .url +
                                        `?job=${ToSeoUrl(item.JOB_TITLE)}&id=${item.INTERNSHIP_ID
                                        }&l=${10}&p=${1}&s=all`
                                      }
                                    >
                                      <p>{item.applyCount}</p>
                                    </Link>
                                  )} */}
                                  {/* <Link target="_blank" to={constant.component.CampusInternshipApplicationList.url + `?job=${ToSeoUrl(item.JOB_TITLE)}&id=${item.INTERNSHIP_ID}&l=${10}&p=${1}&s=all`}><p >{item.applyCount}</p></Link> */}
                                </td>
                              </tr>
                              {openedCommentBoxJobId &&
                                this.state.showCommentBox &&
                                openedCommentBoxJobId == item.INTERNSHIP_ID && (
                                  <tr>
                                    <td colSpan={6} style={{ width: "100%" }}>
                                      <div className="text-right" style={{ width: "100%" }}>
                                        <textarea
                                          className="form-group"
                                          name={COMMENT.name}
                                          value={COMMENT.value}
                                          onChange={this.onChange}
                                          style={{
                                            width: "100%",
                                            padding: "5px",
                                            border: "2px solid #ddd",
                                            borderRadius: "3px"
                                          }}
                                        ></textarea>
                                        <button
                                          className="btn btn-danger btn-sm"
                                          onClick={() => {
                                            this.addComment(item);
                                          }}
                                        >
                                          Add Comment
                                        </button>
                                      </div>
                                      <div>
                                        {item.COMMENT_DETAIL.length > 0 &&
                                          item.COMMENT_DETAIL.map((i) => {
                                            return (
                                              <div
                                                style={{ width: "100%" }}
                                                colSpan="5"
                                              >
                                                <span>
                                                  {i.EMAIL}{" "}
                                                  <a
                                                    onClick={() => {
                                                      this.removeComment(
                                                        i.COMMENT_ID
                                                      );
                                                    }}
                                                  >
                                                    <i className="fa fa-trash"></i>
                                                  </a>
                                                </span>
                                                <br />
                                                <span className="commenttext">
                                                  {" "}
                                                  {i.COMMENT}
                                                </span>
                                                <span className="commentDate">
                                                  {" "}
                                                  {moment(i.MODIFIED_ON).format(
                                                    "DD-MMM-YYYY  hh:mm:ss"
                                                  )}
                                                </span>
                                              </div>
                                            );
                                          })}
                                      </div>
                                    </td>
                                  </tr>
                                )}
                            </>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="filterareabox">

            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  {
                    <div
                      className="paginationshowbox"
                      style={{ margin: "4px" }}
                    >
                      <span>
                        Showing {LIMIT.value * PAGE.value - (LIMIT.value - 1)}{" "}
                        to{" "}
                        {COUNT >= LIMIT.value * PAGE.value
                          ? LIMIT.value * PAGE.value
                          : LIMIT.value * PAGE.value -
                          (LIMIT.value * PAGE.value - COUNT)}{" "}
                        of {COUNT}
                      </span>
                      <ul>
                        {PAGE && (
                          <Pagination
                            activePage={+PAGE.value}
                            itemsCountPerPage={LIMIT.value}
                            totalItemsCount={COUNT ? COUNT : 0}
                            pageRangeDisplayed={5}
                            onChange={this.onPageChange}
                            itemClass="page-item"
                            linkClass="page-link"
                          />
                        )}
                      </ul>
                    </div>
                  }
                </div>

              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }

  removeComment = (COMMENT_ID) => {
    deleteJobComment({
      COMMENT_ID: COMMENT_ID,
    }).then((res) => {
      if (res.status) {
        this.loadList();
      } else {
        Swal.fire({
          icon: "error",
          text: res.error,
          timer: 1500,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    });
  };
  addComment = (data) => {
    const ud = getStorage(constant.keys.userDetails);
    if (this.state.COMMENT.value.length > 0) {
      addJobComment({
        INTERNSHIP_ID: data.INTERNSHIP_ID,
        EMAIL: ud.EMAIL,
        COMMENT: this.state.COMMENT.value,
      }).then((res) => {
        if (res.status) {
          this.loadList();
        } else {
          Swal.fire({
            icon: "error",
            text: res.error,
            timer: 1500,
            showCancelButton: false,
            showConfirmButton: false,
          });
        }
      });
    }
    this.setState({ COMMENT: { ...this.COMMENT, value: "" } });
  };
  loadList = () => {
    const { FILTER_BY, LIMIT, PAGE, KEYWORD, COUNT, LIST } = this.state;

    postedCampusInternshipList({
      FILTER_BY: FILTER_BY.value,
      PAGE: PAGE.value,
      LIMIT: LIMIT.value,
      KEYWORD: KEYWORD.value,
    })
      .then((res) => {
        if (res.status) {
          this.setState({
            LIST: res.result.list.map((item) => {
              // item.showTextArea = false
              return item;
            }),
            COUNT: res.result.count,
          });
        } else {
          alert(res.error);
        }
      })
      .catch((err) => {
        alert(err);
      });
  };
}
